export default "__VITE_ASSET__9TWCD0xs__"